export default __webpack_public_path__ + "media/images/icons/icon-close-c0a6ac38811cc23b6db442b97c9abd00.svg";